import { Component } from '@angular/core';
import { StockCountSandbox } from 'app/core/sandboxes/stock-count.sandbox';
import { CustomerInfo } from 'app/core/store/customer-info/customer-info.interface';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { StockCountState } from 'app/core/store/stock-count/stock-count.interface';
import { BaseContainer } from 'app/modules/base/BaseContainer';
import { distinctUntilChanged, map, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-stock-count-print',
  templateUrl: './stock-count-print.component.html',
  styleUrls: ['./stock-count-print.component.scss'],
})
export class StockCountPrintComponent extends BaseContainer {
  selectedShipTo: string;
  fullShipTos: Definition[];
  shipTos: Definition[] = [];

  constructor(private sandbox: StockCountSandbox) {
    super();
    this.store
      .select('customerInfo')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((customerInfo: CustomerInfo) => ({
          shipTos: customerInfo.customer ? customerInfo.customer.shipTos : null,
          customerNr: customerInfo.customer ? customerInfo.customer.id : null,
        })),
        distinctUntilChanged()
      )
      .subscribe(({ shipTos, customerNr }) => {
        if (shipTos && customerNr) {
          this.fullShipTos = shipTos;
          this.sandbox.getShipTos(customerNr);
        }
      });

    this.store
      .select('stockCount')
      .pipe(
        takeWhile(() => !this.destroyed),
        map((stockCount: StockCountState) => ({
          shipTos: stockCount.shipTos.data,
        })),
        distinctUntilChanged()
      )
      .subscribe(({ shipTos }) => {
        this.shipTos = shipTos ? shipTos : this.shipTos;
      });
  }

  backClicked() {
    this.sandbox.cancelCreate();
  }
}
